import { render, staticRenderFns } from "./editor-info.vue?vue&type=template&id=f3374d72&"
import script from "./editor-info.vue?vue&type=script&lang=js&"
export * from "./editor-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports